import axios from "axios";
import { toast } from "react-toastify";


import { API_URL } from "constants/apiConstants";

// Dùng một ID cố định để tránh lặp
const TOO_MANY_REQUESTS_TOAST_ID = "rate-limit-toast";
const ERR_NETWORK_TOAST_ID = "err-network-toast";

// Create a base axios instance for general API requests
export const axiosApi = axios.create({
    baseURL: API_URL,
    headers: {
        // "Content-Type": "application/json",
    },
});

// Create a custom axios instance for authentication-related requests  ( For old logic )
// export const axiosAuthApi = (headers) =>
//     axios.create({
//         baseURL: API_URL,
//         headers: {
//             ...headers,
//             // "Content-Type": "application/json",
//         },
//     });
export const axiosAuthApi = (headers) => {
    const instance = axios.create({
        baseURL: API_URL,
        headers: {
            ...headers,
        },
    });

    // Gắn interceptor giống axiosApi
    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error.response?.status;
            if (status === 401) {
                console.log("Unauthorized from axiosAuthApi");
                toast.error("Unauthorized. Please log in again.");
            }
            if (status === 429) {
                if (!toast.isActive(TOO_MANY_REQUESTS_TOAST_ID)) {
                    toast.error(
                        "You’ve reached the request limit. Please wait a few seconds before trying again.",
                        { toastId: TOO_MANY_REQUESTS_TOAST_ID }
                    );
                }
            }
            return Promise.reject(error);
        }
    );

    return instance;
};


// Optional: Add interceptors for centralized request/response handling
axiosApi.interceptors.request.use(
    (config) => {
        // Add Authorization token if it exists in localStorage
        const token = localStorage.getItem("token");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosApi.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle common errors here (e.g., 401 Unauthorized, 500 Server errors)
        if (error.response) {
            const status = error.response.status;
            if (status === 401) {
                // Redirect to login or show login modal
                console.log("Unauthorized, redirecting to login...");
            }
            if (status === 429) {
                if (!toast.isActive(TOO_MANY_REQUESTS_TOAST_ID)) {
                    toast.error(
                        "You’ve reached the request limit. Please wait a few seconds before trying again.",
                        { toastId: TOO_MANY_REQUESTS_TOAST_ID }
                    );
                }
            }
            console.error("API Error:", error.response);
        }
        else if (error.message === "Network Error") {
            toast.error(
                error.message,
                { toastId: ERR_NETWORK_TOAST_ID }
            );
        }
        return Promise.reject(error);
    }
);

// Sample utility function for making requests with async/await
export const getData = async (endpoint) => {
    try {
        const response = await axiosApi.get(endpoint);
        // return response.data;
        return response;
    } catch (error) {
        console.error("Failed to fetch data:", error);
        throw error;
    }
};

